import { fixed, money, percentage, formatDate } from './filters'

export default {
  install (Vue: { filter: (arg0: string, arg1: (value: any) => any) => void }) {
    Vue.filter('fixed', fixed)
    Vue.filter('money', money)
    Vue.filter('percentage', percentage)
    Vue.filter('formatDate', formatDate)
  }
}
